module.exports = __webpack_public_path__ + "img/dots.3d8ca83.svg";